import React, { useState } from 'react'
import cookie from 'js-cookie'
import styled from 'react-emotion'
import { SubmitButton } from '../../application'


const Info = styled('div')`
  display: flex;
  flex-direction: row;
  background-color: #e7e3db; 
  margin-bottom: 20px;
  padding: 10px 10px 1px 10px;
  border-radius: 5px;  
  border: 0;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.1);
  color: #092a5e;  
  @media (max-width: 992px) {
    padding-bottom: 10px;
    padding-right: 10px;
    a {
      margin-top: 5px;
      display: block;
    }
  }
`
const Flex = styled('div')`
  display: flex;
  align-items: flex-start;
  input {
    padding: 0 10px;
    margin-right: 10px;    
    height: 36px;
    width: 400px;
  }
  >div {
    min-width: 200px;
    margin-right: 10px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    >div, .btn.btn-sm {
      min-width: unset;
      width: 100%;
      margin-right: 0;
    }
    input {
      width: 100%;      
    }
  }
`
const Field = styled('div')`
`

const Form = styled('form')`
    margin-bottom: 7px;
    width: 100%;
`

export default () => {
    const [UID, setUID] = useState(null)
    const isImpersonating = !!cookie.get("customer.mytui.web.impersonate.uid")

    const onChange = (e) => {
        setUID(e.target.value)
    }
    const handleSignout = (e) => {
        cookie.remove("customer.mytui.web.impersonate.uid")
    }
    const handleSubmit = (e) => {
        cookie.set("customer.mytui.web.impersonate.uid", UID)
    }
    return (
        <div>
            {isImpersonating
                ? <Info>
                    <Form onSubmit={handleSignout}>
                        <Flex>
                            <SubmitButton className="btn-sm" text="Logga ut som användare" />
                        </Flex>
                    </Form>
                </Info>
                : <Info>
                    <form onSubmit={handleSubmit}>
                        <p>Ange UID tillhörande önskad användare:</p>
                        <Flex>
                            <Field className='form-group'>
                                <input
                                    className={`form-control`}
                                    id={`UID`}
                                    type='text'
                                    placeholder="Användarens UID"
                                    onChange={onChange}
                                />
                            </Field>
                            <SubmitButton className="btn-sm" text="Ladda användarkonto" />
                        </Flex>
                    </form>
                </Info>
            }
        </div>
    )
}